<div class="custom-context-menu-wrapper" [@fadeInOut] (click)="$event.stopPropagation()">
  @if (history.length > 0) {
    <app-interactive-list-item
      [itemText]="'Global.Back' | translate"
      [itemIcon]="'arrow_back'"
      (itemClicked)="goBack()"
    ></app-interactive-list-item>
    <div class="menu-divider"></div>
  }
  @for (item of activeMenuItems; track item) {
    @if (item.divider) {
      <div class="menu-divider"></div>
    }
    <app-interactive-list-item
      [itemText]="item.text | translate"
      [itemIcon]="item.icon"
      [isSvgIcon]="item.isSvgIcon || false"
      [disabled]="item.disabled"
      [badge]="item.badge"
      [data]="item"
      (itemClicked)="onItemClicked(item)"
      (mouseenter)="item.onMouseEnter ? item.onMouseEnter(item.data) : null"
      (mouseleave)="item.onMouseLeave ? item.onMouseLeave(item.data) : null"
      [class.disabled]="item.disabled"
      [attr.aria-disabled]="item.disabled"
    ></app-interactive-list-item>
  }
</div>
